import { useCallback, useRef } from 'react';
import { useMutation } from '@tanstack/react-query';

import Client from './client';

import type { UseMutationOptions } from '@tanstack/react-query';

export const useSendDownloadSms = (
  options: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof Client.sendDownloadAppSms>>,
      Error,
      void,
      unknown
    >,
    'mutationFn'
  > = {},
) => {
  const sentRef = useRef(false);
  const { mutateAsync, status } = useMutation({
    mutationKey: ['sendDownloadSms'],
    mutationFn: Client.sendDownloadAppSms,
    ...options,
  });

  const sendDownloadSms = useCallback(() => {
    if (status === 'pending' || status === 'success' || sentRef.current) {
      return;
    }

    sentRef.current = true;
    return mutateAsync();
  }, [status, mutateAsync]);

  return {
    sendDownloadSms,
  };
};
